import { zodResolver } from "@hookform/resolvers/zod";
import { Building2, LogOut } from "lucide-react";
import { memo, useEffect } from "react";
import { useForm } from "react-hook-form";

import { ProfileData, profileSchema } from "../model";

import { UserProfileDTO } from "@/common/api";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@/common/components";
import { useAuth } from "@/common/hooks";

interface ProfileFormProps {
  isPending: boolean;
  data: UserProfileDTO;
  onSubmit: (data: UserProfileDTO) => void;
  onCancel: () => void;
}

export const ProfileForm = memo<ProfileFormProps>(({ isPending, data, onSubmit, onCancel }) => {
  const { logout } = useAuth();

  const form = useForm<ProfileData>({
    resolver: zodResolver(profileSchema),
    mode: "onChange",
    defaultValues: {
      username: "",
      login: "",
      email: "",
      contactNumber: "",
    },
  });
  const isReadOnly = true;

  useEffect(() => {
    if (data) {
      form.reset({ ...data });
    }
  }, [data, form]);

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6" noValidate>
        {/* Основная информация о пользователе */}
        <fieldset disabled={isReadOnly}>
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2 md:text-2xl text-lg md:font-semibold font-bold md:leading-7 leading-6">
                <Building2 className="md:h-6 h-5 md:w-6 w-5" />
                Основная информация профиля
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 md:gap-y-6 gap-y-4">
                <FormField
                  control={form.control}
                  name="username"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Имя пользователя</FormLabel>
                      <FormControl>
                        <Input placeholder="Введите имя" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="login"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Логин</FormLabel>
                      <FormControl>
                        <Input placeholder="Введите логин" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="email"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Электронная почта</FormLabel>
                      <FormControl>
                        <Input placeholder="Введите электронную почту" type="email" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="contactNumber"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Номер телефона</FormLabel>
                      <FormControl>
                        <Input placeholder="+7xxxxxxxxxx" {...field} value={field.value || ""} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
            </CardContent>
          </Card>
        </fieldset>

        {/* Кнопки действий */}
        <div className="flex md:flex-row flex-col justify-end gap-3">
          <Button
            variant="ghost"
            onClick={logout}
            className={`hover:bg-red-500/20 border hover:border-red-500 hover:text-red-500 flex items-center gap-2 text-black border-black/30`}
          >
            <LogOut className="h-4 w-4" />
            Выйти
          </Button>
          {/* <Button type="button" variant="outline" onClick={onCancel}>
            Отменить
          </Button> */}

          {/* <Button
            type="submit"
            variant="secondary"
            disabled={isPending}
            className="flex items-center md:gap-2"
          >
            {isPending && <Loader2 className="h-4 w-4 animate-spin" />}
            <Send className="md:block hidden h-4 w-4" />
            Отправить изменения на проверку
          </Button> */}
        </div>
      </form>
    </Form>
  );
});
